import React from 'react';
export function Footer() {
  return <footer className="bg-warmBrown text-cream py-16" data-id="element-65" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto px-6" data-id="element-66" data-mp="3gfsnyg23r0ok">
        <div className="grid md:grid-cols-4 gap-12 mb-12" data-id="element-67" data-mp="3ggk8mvu5ve02">
          <div className="md:col-span-2" data-id="element-68" data-mp="32onjn0nshk7w">
            <div className="flex items-center gap-2 mb-6" data-id="element-69" data-mp="32pp39tivff18">
              <img src="https://cdn.magicpatterns.com/uploads/mMVV4XoPmsr1QmNTgf4DWX/icon.png" alt="Pawchi logo" className="w-9 h-9 rounded-lg" data-id="element-70" data-mp="36qhgsyys063b" />
              <span className="font-logo font-semibold text-2xl tracking-tight" data-id="element-71" data-mp="37o2ul235f8m">
                Pawchi
              </span>
            </div>
            <p className="text-cream/60 max-w-sm leading-relaxed" data-id="element-72" data-mp="3lgooqkr5q6pr">
              Turning your real pet into a cute self-care companion. Build
              better routines, stay consistent, and take care of yourself —
              together.
            </p>
          </div>

          <div data-id="element-73" data-mp="2ezutxlxrg8lq">
            <h4 className="font-bold text-lg mb-6" data-id="element-74" data-mp="2ew716p053q82">Product</h4>
            <ul className="space-y-4" data-id="element-75" data-mp="3laljxq66apz8">
              <li data-id="element-76" data-mp="3lbddywk4gfne">
                <a href="#features" className="text-cream/60 hover:text-peach transition-colors" data-id="element-77" data-mp="3gapc1fucueee">
                  Features
                </a>
              </li>
              <li data-id="element-78" data-mp="3q83pr7ow8p30">
                <a href="#how-it-works" className="text-cream/60 hover:text-peach transition-colors" data-id="element-79" data-mp="3q7lr64erdyrx">
                  How it works
                </a>
              </li>
              <li data-id="element-80" data-mp="33nna8afjnlr">
                <a href="#testimonials" className="text-cream/60 hover:text-peach transition-colors" data-id="element-81" data-mp="3231b726lczi">
                  Stories
                </a>
              </li>
              <li data-id="element-82" data-mp="qt8h5m84g59t">
                <a href="#" className="text-cream/60 hover:text-peach transition-colors" data-id="element-83" data-mp="qsqfga2owyui">
                  Pricing
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-84" data-mp="twxtpgfxzmch">
            <h4 className="font-bold text-lg mb-6" data-id="element-85" data-mp="tta0yjibn3yt">Company</h4>
            <ul className="space-y-4" data-id="element-86" data-mp="yuz9nsi2n5jq">
              <li data-id="element-87" data-mp="yrv4arsve3rh">
                <a href="#" className="text-cream/60 hover:text-peach transition-colors" data-id="element-88" data-mp="13sr3is2a11qk">
                  About Us
                </a>
              </li>
              <li data-id="element-89" data-mp="1cm484r9pdrsh">
                <a href="/creator" className="text-cream/60 hover:text-peach transition-colors" data-id="element-90" data-mp="1ckt18ikyo3x5">
                  Creator Program
                </a>
              </li>
              <li data-id="element-91" data-mp="1mkjvqk9iuix8">
                <a href="/contact-us" className="text-cream/60 hover:text-peach transition-colors" data-id="element-92" data-mp="1mhxroulualjr">
                  Contact Us
                </a>
              </li>
              <li data-id="element-93" data-mp="3t9yhdnlg0e1l">
                <a href="/privacy-policy" className="text-cream/60 hover:text-peach transition-colors" data-id="element-94" data-mp="3t9gfobg0h7ma">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-95" data-mp="25mu7wokrmto7">
                <a href="/terms-of-use" className="text-cream/60 hover:text-peach transition-colors" data-id="element-96" data-mp="25mann17n7t70">
                  Terms of Service
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-97" data-mp="2tdg1xbxxqdf7">
          <p className="text-cream/40 text-sm" data-id="element-98" data-mp="2pd5zuad9k75m">
            © {new Date().getFullYear()} Pawchi App. All rights reserved.
          </p>
        </div>
      </div>
    </footer>;
}